import React from "react";
import { Redo } from "@mui/icons-material";

import { HistoryContext, useHistory } from "fond/history";
import { getHotkeyLabel, useHotkeys } from "fond/hooks/useHotkeys";

import { IButtonProps } from "./Toolbar";
import ToolbarButton from "./ToolbarButton";

const RedoButton: React.FC<IButtonProps> = ({ icon, mode, title = "Redo", ...rest }) => {
  const { canRedo, redo } = useHistory(HistoryContext);
  const isDisabled =
    !canRedo ||
    (!!mode && !["simple_select", "direct_select", "static", "draw_point", "draw_line_string", "draw_polygon", "lasso_select"].includes(mode));

  useHotkeys({
    action: "REDO",
    callback: (event) => {
      event.preventDefault();
      redo();
    },
    enabled: !isDisabled,
  });

  const handleOnClick = () => {
    redo();
  };

  const tooltipTitle = `${title} (${getHotkeyLabel("REDO")})`;

  return (
    <ToolbarButton title={title} {...rest} tooltip={tooltipTitle} onClick={handleOnClick} disabled={isDisabled} data-testid="toolbar-redo-button">
      {icon || <Redo />}
    </ToolbarButton>
  );
};

export default RedoButton;
